export default {
  'sv-SE': {
    documenteditor: {
      A3: 'A3',
      A4: 'A4',
      A5: 'A5',
      Address: 'Adress',
      After: 'Efter',
      'After text': 'Efter text',
      'Aligned at': 'Justerat kl',
      Alignment: 'Inriktning',
      All: 'Allt',
      'All Done': 'Helt klar',
      'Allow row to break across pages': 'Låt raden bryta över sidor',
      'Allow spacing between cells': 'Tillåt avstånd mellan celler',
      'Apply To': 'Ansöka till',
      Arabic: 'Arabiska',
      At: 'På',
      'At least': 'Minst',
      'Available styles': 'Tillgängliga stilar',
      B4: 'B4',
      B5: 'B5',
      Before: 'Innan',
      'Before text': 'Före text',
      Bold: 'Djärv',
      Bookmark: 'Bokmärke',
      'Bookmark name': 'Bokmärkesnamn',
      Borders: 'Gränser',
      'Borders and Shading': 'Gränser och skuggning',
      Bottom: 'Botten',
      Box: 'Låda',
      'Build table of contents from': 'Bygg innehållsförteckning från',
      Bullet: 'Kula',
      Bullets: 'Kulor',
      By: 'Förbi',
      Cancel: 'Avbryt',
      Cell: 'Cell',
      'Cell margins': 'Cellmarginaler',
      'Cell Options': 'Cellalternativ',
      Center: 'Centrum',
      'Choose level to modify': 'Välj nivå för att ändra',
      'Click to follow link': 'Klicka för att följa länken',
      Close: 'Stänga',
      Color: 'Färg',
      'Continue Numbering': 'Fortsätt numreringen',
      Copy: 'Kopia',
      'Copy Hyperlink': 'Kopiera hyperlänk',
      'Create New Style': 'Skapa ny stil',
      Custom: 'Beställnings',
      'Custom Size': 'Anpassad storlek',
      Cut: 'Skära',
      DashDot: 'DashDot',
      DashDotDot: 'DashDotDot',
      DashDotStroked: 'DashDot Stroked',
      DashLargeGap: 'DashLargeGap',
      DashSmallGap: 'DashSmallGap',
      'Default cell margins': 'Standardcellmarginaler',
      'Default cell spacing': 'Standardcellavstånd',
      'Define new Multilevel list': 'Definiera den nya multilevel-listan',
      Delete: 'Radera',
      'Delete Column': 'Radera kolumn',
      'Delete Row': 'Radera rad',
      'Delete Table': 'Radera tabell',
      'Different first page': 'Olika första sidan',
      'Different odd and even': 'Olika udda och jämnt',
      Dot: 'Punkt',
      Double: 'Dubbel',
      'Double strikethrough': 'Dubbel genomsträckning',
      DoubleWavy: 'DoubleWavy',
      'Edit Field': 'Redigera fält',
      'Edit Hyperlink': 'Redigera Hyperlink',
      Effects: 'effekter',
      Emboss3D: 'Emboss3D',
      Engrave3D: 'Gravera 3D',
      'Enter formatting for number': 'Ange formatering för nummer',
      Exactly: 'Exakt',
      Executive: 'Verkställande',
      'File Name': 'Filnamn',
      Fill: 'Fylla',
      Find: 'Hitta',
      'First line': 'Första linjen',
      'Follow number with': 'Följ nummer med',
      Font: 'Font',
      'Font color': 'Fontfärg',
      'Font style': 'Typsnitt',
      Footer: 'sidfot',
      'For East': 'För öst',
      Format: 'Formatera',
      Formatting: 'formatering',
      'Format Type': 'Formattyp',
      'From edge': 'Från kanten',
      General: 'Allmän',
      Hanging: 'Hängande',
      Header: 'Rubrik',
      Heading: 'Rubrik',
      Height: 'Höjd',
      Hyperlink: 'hyper~~POS=TRUNC',
      Indentation: 'Indrag',
      'Indent from left': 'Intryck från vänster',
      Insert: 'Föra in',
      'Insert Above': 'Sätt in ovanför',
      'Insert Below': 'Infoga nedan',
      'Insert Hyperlink': 'Sätt i Hyperlink',
      'Insert Left': 'Sätt in vänster',
      'Insert Right': 'Sätt in höger',
      'Insert Table': 'Sätt in tabell',
      Inset: 'Infälld',
      instances: 'instanser',
      Italic: 'Kursiv',
      Justify: 'Rättfärdiga',
      Landscape: 'Landskap',
      Layout: 'Layout',
      'Leading zero': 'Ledande noll',
      Left: 'Vänster',
      Legal: 'Rättslig',
      Letter: 'Brev',
      Level: 'Nivå',
      'Line Spacing': 'Radavstånd',
      'List level': 'Listnivå',
      'List Paragraph': 'Lista stycke',
      LowLetter: 'LowLetter',
      LowRoman: 'LowRoman',
      Margin: 'marginaler',
      'Measure in': 'Mät in',
      'Merge Cells': 'Sammanfoga celler',
      Modify: 'Ändra',
      'Modify Style': 'Ändra stil',
      Multiple: 'Flera olika',
      Name: 'namn',
      Navigation: 'Navigering',
      New: 'Ny',
      'No bookmarks found': 'Inga bokmärken hittades',
      'No matches': 'Inga träffar',
      None: 'Ingen',
      'No Restart': 'Ingen omstart',
      Normal: 'Vanligt',
      Nothing: 'Ingenting',
      Number: 'siffra',
      'Number format': 'Nummerformat',
      'Number format tooltip information':
        'Enkelsnivåformat: </br> [PREFIX]% [LEVELNUMBER] [SUFFIX] </br> Till exempel, kapitel% 1. kommer att visa numrering som </br> Kapitel 1. Objekt </br> Kapitel 2. Objekt </br> ... </br> Kapitel N. Objekt </br> </br> Flernivåformat: </ br > [PREFIX]% [LEVELNUMBER] [SUFFIX] + [PREFIX]% [LEVELNUMBER] [SUFFIX] </br> Till exempel% 1.% 2. kommer att visa numrering som </br> 1.1. Punkt </br> 1,2. Punkt </br> ... </br> 1.N. Artikel',
      Numbering: 'Numrering',
      'Numbering and Bullets': 'Nummerering och kulor',
      'Number of columns': 'Antal kolumner',
      'Number of rows': 'Antal rader',
      'Number style for this level': 'Nummerstil för denna nivå',
      of: 'av',
      Ok: 'Ok',
      'Open Hyperlink': 'Öppna Hyperlink',
      Options: 'alternativ',
      Ordinal: 'ORDNINGS-',
      'Ordinal Text': 'Vanlig text',
      Orientation: 'Orientering',
      'Outline levels': 'Konturnivåer',
      Outset: 'Början',
      'Page Setup': 'Utskriftsformat',
      Paper: 'Papper',
      Paragraph: 'Paragraf',
      Paste: 'Klistra',
      Percent: 'Procent',
      Points: 'Points',
      Portrait: 'Porträtt',
      Position: 'Placera',
      'Preferred Width': 'Föredragen bredd',
      Preview: 'Förhandsvisning',
      Properties: 'Egenskaper',
      Regular: 'Regelbunden',
      'Remove Hyperlink': 'Ta bort Hyperlink',
      'Repeat as header row at the top of each page':
        'Upprepa som rubrikrad längst upp på varje sida',
      Replace: 'Byta ut',
      'Replace All': 'Ersätt alla',
      'Restart At': 'Starta om kl',
      'Restart list after': 'Starta om listan efter',
      Result: 'Resultat',
      Results: 'Resultat',
      Right: 'Rätt',
      'Right align page numbers': 'Högerjustera sidnummer',
      Row: 'Rad',
      'Row height is': 'Radhöjd är',
      'Same as the whole table': 'Samma som hela tabellen',
      Save: 'Spara',
      Setting: 'Miljö',
      Shading: 'Skuggning',
      'Show levels': 'Visa nivåer',
      'Show page numbers': 'Visa sidnummer',
      Single: 'Enda',
      SingleWavy: 'SingleWavy',
      Size: 'Storlek',
      Space: 'Plats',
      Spacing: 'Mellanrum',
      Special: 'Särskild',
      'Specify height': 'Ange höjd',
      'Start at': 'Börja på',
      Statement: 'Påstående',
      Strikethrough: 'struken',
      Style: 'Stil',
      'Style based on': 'Stil baserad på',
      'Style for following paragraph': 'Stil för följande stycke',
      Styles: 'Styles',
      'Style type': 'Stil typ',
      Subscript: 'Index',
      Superscript: 'Exponent',
      'Tab character': 'Fliktecken',
      Table: 'Tabell',
      'Tab leader': 'Tab-ledare',
      'Table entry fields': 'Fält för tabellinmatning',
      'Table Of Contents': 'Innehållsförteckning',
      'Table of Contents': 'Innehållsförteckning',
      'Table Options': 'Tabellalternativ',
      'Table Properties': 'Tabellegenskaper',
      Tabloid: 'tabloid',
      'Text indent at': 'Textintryck kl',
      'Text to display': 'Text som ska visas',
      Thick: 'Tjock',
      ThickThinLargeGap: 'ThickThinLargeGap',
      ThickThinMediumGap: 'TjockTunnMediumGap',
      ThickThinSmallGap: 'TjockThinSmallGap',
      ThinThickLargeGap: 'ThinThickLargeGap',
      ThinThickMediumGap: 'ThinThickMediumGap',
      ThinThickSmallGap: 'ThinThickSmallGap',
      ThinThickThinLargeGap: 'ThinThickThinLargeGap',
      ThinThickThinMediumGap: 'ThinThickThinMediumGap',
      ThinThickThinSmallGap: 'ThinThickThinSmallGap',
      'TOC level': 'TOC-nivå',
      Top: 'Topp',
      Triple: 'Trippel',
      'Underline style': 'Understrykningsstil',
      'Update Field': 'Uppdatera fältet',
      UpLetter: 'UpLetter',
      UpRoman: 'UpRoman',
      'Use bookmarks': 'Använd bokmärken',
      'Use hyperlinks instead of page numbers':
        'Använd hyperlänkar istället för sidnummer',
      'Vertical alignment': 'Vertikal justering',
      'We replaced all': 'Vi ersatte alla',
      Width: 'Bredd',
      with: 'med',
    },
    documenteditorcontainer: {
      'Add or edit the footer': 'Lägg till eller redigera sidfoten.',
      'Add or edit the header': 'Lägg till eller redigera rubriken.',
      'Add page numbers': 'Lägg till sidnummer.',
      'Align bottom': 'Justera botten',
      'Align center': 'Centrera i linje med',
      'Align left Tooltip': 'Justera vänster (Ctrl + L)',
      'Align right Tooltip': 'Justera höger (Ctrl + R)',
      'Align Text': 'Justera text',
      'Align top': 'Rikta in toppen',
      'All borders': 'Alla gränser',
      AllCaps: 'AllCaps',
      'Aspect ratio': 'Sidförhållande',
      'Bold Tooltip': 'Fet (Ctrl + B)',
      Bookmark: 'Bokmärke',
      'Border color': 'Gräns ​​färg',
      Borders: 'Gränser',
      'Border Style': 'Gränsstil',
      'Border width': 'Gränsbredd',
      Bottom: 'Botten',
      'Bottom border': 'Nedre gränsen',
      'Bottom margin': 'Nedre marginal',
      Break: 'Ha sönder',
      Bullets: 'Kulor',
      'By URL': 'Med URL',
      Cancel: 'Avbryt',
      Cell: 'Cell',
      'Cell Margin': 'Cellmarginalen',
      'Center Tooltip': 'Center (Ctrl + E)',
      'Change case Tooltip': 'Ändra ärende',
      'Check Box': 'Kryssruta',
      'Clear all formatting': 'Rensa all formatering',
      'Column Break': 'Columns',
      Columns:
        'Show the hidden characters like spaces, tab, paragraph marks, and breaks.(Ctrl + *)',
      Comments: 'kommentarer',
      'Create a new document': 'Skapa ett nytt dokument.',
      'Create Hyperlink':
        'Skapa en länk i ditt dokument för snabb åtkomst till webbsidor och filer (Ctrl + K).',
      'Current Page Number':
        'Det aktuella sidnumret i dokumentet. Klicka eller tryck på för att navigera på en specifik sida.',
      'Decrease indent': 'Minska indraget',
      'Delete columns': 'Radera kolumner',
      'Delete rows': 'Radera rader',
      'Different First Page': 'Olika första sidan',
      'Different header and footer for first page':
        'Olika sidhuvud och sidfot för första sidan.',
      'Different header and footer for odd and even pages':
        'Olika sidhuvud och sidfot för udda och jämna sidor.',
      'Different Odd And Even Pages': 'Olika udda & jämna sidor',
      'Distance from bottom of the page to bottom of the footer':
        'Avstånd från botten av sidan till botten av sidfot.',
      'Distance from top of the page to top of the header':
        'Avstånd från toppen av sidan till toppen av rubriken.',
      Double: 'Dubbel',
      DropDown: 'Falla ner',
      'Endnote Tooltip': 'Infoga slutnot (Alt + Ctrl + D).',
      'Error in establishing connection with web server':
        'Fel vid upprättande av anslutning till webbservern',
      Fill: 'Fylla',
      'Fill color': 'Fyllnadsfärg',
      Find: 'Hitta',
      'Find Text': 'Hitta text i dokumentet (Ctrl + F).',
      'Fit one page': 'Montera en sida',
      'Fit page width': 'Montera sidbredden',
      Font: 'Font',
      'Font color': 'Fontfärg',
      'Font Size': 'Textstorlek',
      Footer: 'sidfot',
      'Footer from Bottom': 'Sidfot från botten',
      'Footnote Tooltip': 'Infoga fotnot (Alt + Ctrl + F).',
      'Form Fields': 'Formfält',
      H: 'H',
      Header: 'Rubrik',
      'Header And Footer': 'Header & Footer',
      'Header from Top': 'Rubrik från toppen',
      Heading: 'Rubrik',
      'HEADING - - - - 1': 'RADNING - - - - 1',
      'HEADING - - - - 2': 'RADNING - - - - 2',
      'HEADING - - - - 3': 'RADNING - - - - 3',
      'Heading 1': 'Rubrik 1',
      'Heading 2': 'Rubrik 2',
      'Heading 3': 'Rubrik 3',
      'Heading 4': 'Rubrik 4',
      'Heading 5': 'Rubrik 5',
      'Heading 6': 'Rubrik 6',
      Height: 'Höjd',
      'Hide properties pane': 'Dölj egenskaper-rutan',
      Image: 'Bild',
      'Increase indent': 'Öka indrag',
      Insert: 'Föra in',
      'Insert a bookmark in a specific place in this document':
        'Sätt in ett bokmärke på en specifik plats i det här dokumentet.',
      'Insert a table into the document': 'Sätt i en tabell i dokumentet',
      'Insert columns to the left': 'Sätt in kolumner till vänster',
      'Insert columns to the right': 'Sätt in kolumner till höger',
      'Insert Endnote': 'Infoga slutnot',
      'Insert Footnote': 'Infoga fotnot',
      'Insert inline picture from a file': 'Sätt in inbyggd bild från en fil.',
      'Insert Or Delete': 'Infoga / radera',
      'Insert rows above': 'Sätt i raderna ovan',
      'Insert rows below': 'Sätt i raderna nedan',
      'Inside borders': 'Inre gränser',
      'Inside horizontal border': 'Inuti horisontell kant',
      'Inside vertical border': 'Inuti vertikal kant',
      'Italic Tooltip': 'Kursiv (Ctrl + I)',
      'Justify Tooltip': 'Motivera (Ctrl + J)',
      Left: 'Vänster',
      'Left border': 'Vänster gräns',
      'Left margin': 'Vänster marginal',
      Levels: 'nivåer',
      'Line spacing': 'Radavstånd',
      Link: 'Länk',
      'Local Clipboard': 'Lokal Urklipp',
      'Manage Styles': 'Hantera stilar',
      'Merge cells': 'Sammanfoga celler',
      New: 'Ny',
      'New comment': 'Ny kommentar',
      'No Border': 'Ingen gräns',
      'No color': 'Ingen färg',
      None: 'Ingen',
      Normal: 'Vanligt',
      Numbering: 'Numrering',
      'Number of heading or outline levels to be shown in table of contents':
        'Antal rubrik- eller konturnivåer som ska visas i innehållsförteckningen.',
      of: 'av',
      Open: 'Öppen',
      'Open a document': 'Öppna ett dokument.',
      'Open the page setup dialog': 'Öppna sidinställningsdialogen.',
      Options: 'alternativ',
      'Outside borders': 'Yttre gränser',
      Page: 'Sida',
      'Page Break': 'Sidbrytning',
      'Page Number': 'Sidonummer',
      'Page Setup': 'Utskriftsformat',
      Paragraph: 'Paragraf',
      Position: 'Placera',
      'Print layout': 'Utskriftslayout',
      Protections: 'skydd',
      'Provide an overview of your document by adding a table of contents':
        'Ge en översikt över ditt dokument genom att lägga till en innehållsförteckning.',
      'Read only': 'Endast läsning',
      Redo: 'Göra om',
      'Redo Tooltip': 'Gör om den senaste åtgärden (Ctrl + Y).',
      'Restrict Editing': 'Begränsa redigering',
      Right: 'Rätt',
      'Right align page numbers': 'Högerjustera sidnummer',
      'Right align page numbers in table of contents':
        'Högerjustera sidnummer i innehållsförteckningen.',
      'Right border': 'Höger gräns',
      'Right margin': 'Höger marginal',
      'Section Break': 'Avsnitt Break',
      'ShowHiddenMarks Tooltip':
        'Visa de dolda tecknen som mellanslag, tabb, stycketecken och brytningar.(Ctrl + *)',
      'Show page numbers': 'Visa sidnummer',
      'Show page numbers in table of contents':
        'Visa sidnummer i innehållsförteckningen.',
      'Show properties pane': 'Visa fönstret',
      Single: 'Enda',
      'Spell Check': 'Stavnings kontroll',
      Strikethrough: 'struken',
      Styles: 'Styles',
      'Subscript Tooltip': 'Prenumeration (Ctrl + =)',
      'Superscript Tooltip': 'Exponent (Ctrl + Shift ++)',
      Table: 'Tabell',
      'Table of Contents': 'Innehållsförteckning',
      Text: 'Text',
      'Text Form': 'Textform',
      'Text highlight color': 'Text markera färg',
      'Toggle between the internal clipboard and system clipboard':
        'Växla mellan det interna urklippet och systemklippbordet. </br> Tillgång till systemklippbord via skript nekas på grund av webbläsarnas säkerhetspolicy. Istället </br> 1. Du kan aktivera internt urklipp för att klippa, kopiera och klistra in i komponenten. </br> 2. Du kan använda kortkommandona (Ctrl + X, Ctrl + C och Ctrl + V) för att klippa , kopiera och klistra in med systemklippbordet.',
      Top: 'Topp',
      'Top border': 'Övre gränsen',
      'Top margin': 'Toppmarginal',
      'Track Changes': 'Håll reda på de ändringar som gjorts i dokumentet',
      TrackChanges: 'Spåra ändringar',
      'Underline errors': 'Understrek fel',
      'Underline Tooltip': 'Understreck (Ctrl + U)',
      Undo: 'Ångra',
      'Undo Tooltip': 'Ångra den sista handlingen (Ctrl + Z).',
      Update: 'Uppdatera',
      'Update cross reference fields': 'Uppdatera korsreferensfält',
      'Update Fields': 'Uppdatera fält',
      'Upload from computer': 'Ladda upp från datorn',
      UPPERCASE: 'VERSAL',
      'Use hyperlinks': 'Använd hyperlänkar',
      'Use hyperlinks instead of page numbers':
        'Använd hyperlänkar istället för sidnummer.',
      W: 'W',
      'Web layout': 'Webblayout',
      Width: 'Bredd',
      ZoomLevelTooltip:
        'Zoomnivå. Klicka eller tryck för att öppna zoomalternativen.',
    },
  },
};
